import type { UserState } from './types'
import { DEFAULT_PAGE_ROWS } from 'core/constants'

export const state: UserState = {
  user: {} as any,
  users: [],
  endUsers: [],
  selectedRows: DEFAULT_PAGE_ROWS,
  currentPage: 1,
}
